const CARTOGRAPHIE = {
  title: 'Cartographie',
  steps: {
    recherche: 'Recherche',
    selection: 'Selection ({num})',
    carte: 'Carte',
  },
  tabs: {
    recherche: {
      faces: 'Faces unitaires',
      ecrans: 'Ecrans numériques',
      clients: 'Clients',
      reseaux: 'Réseaux',
    },
    selection: {
      faces: 'Faces unitaires ({number})',
      clients: 'Clients ({number})',
      reseaux: 'Réseaux ({number})',
      ecrans: 'Ecrans numériques ({number})',
    },
  },
  cards: {
    face: {
      emplacement: 'Emplacement',
      faces: 'Face(s)',
      reseau: 'Réseau',
      informations: 'Informations',
      adresseCommerciale: 'Adresse Commerciale',
      format: 'Format',
      materiel: 'Matériel',
      restrictions: 'Restrictions',
      enAllantVers: 'En allant vers',
      enVenantDe: 'En venant de',
      eclaire: 'Eclairé',
      tab: {
        code: 'Code Face',
        etat: 'Etat',
        proposableLc: 'Proposable en LC',
        proposableReseau: 'Proposable en réseau',
      },
      streetView: 'Street view',
      retour: 'Retour',
      affectation: 'Affectation com.',
    },
    client: {
      client: 'Client',
      code: 'Code',
      informations: 'Informations',
      adressePostale: 'Adresse Postale',
      streetView: 'Street view',
      retour: 'Retour',
    },
    ecran: {
      ecran: 'Ecran numérique : ',
    },
  },
  columns: {
    dateSelection: 'Date de visualisation',
  },
  actions: {
    addSelection: 'Ajouter à la sélection',
    removeSelection: 'Supprimer de la sélection',
    applyColor: 'Choisir une couleur',
    withAzimut: 'Afficher les azimuts',
    regroupMateriel: 'Regrouper par matériel',
  },
  popup: {
    title: 'Choisissez une couleur',
    appliquer: 'Appliquer',
  },
};

export default CARTOGRAPHIE;
